import { H1, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import { Citta } from "../../types"
import { useNavigate } from "react-router-dom"
import { Formik } from "formik"
import { Container } from "react-bootstrap"
import BottomFormFixed from "../../components/BottomFormFixed"
import CittaForm from "./CittaForm"
import { useCittaCreate } from "../../hooks/citta"
import { initialValuesCitta, validationSchemaCitta } from "./CittaCommon"
import { useMemo } from "react"
import { ScrollLayout } from "../../components/ScrollLayout"
import { transformErrorForForm } from "../../utils/utils"

export default function CittaCreate() {
  const createCitta = useCittaCreate()
  const navigate = useNavigate()

  useBreadcrumbs([{ label: "Città", href: "/citta/citta" }, { label: "Creazione Città" }])

  const initialValues = useMemo(() => initialValuesCitta(), [])
  const validationSchema = useMemo(() => validationSchemaCitta(), [])

  return (
    <Layout>
      <ScrollLayout hasBottomFixed>
        <H1>Nuova città</H1>
        <ScrollLayout.Scroll>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values, actions) => {
              return createCitta.mutateAsync(values as Citta).then((citta) => {
                navigate(`/citta/citta`)
              }).catch((e) => {
                actions.setErrors(transformErrorForForm(e))
              })
            }}
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Container fluid className="mt-6" style={{ marginBottom: "100px" }}>
                  <CittaForm />
                </Container>
                <BottomFormFixed url="/citta/citta" />
              </form>
            )}
          </Formik>
        </ScrollLayout.Scroll>
      </ScrollLayout>
    </Layout>
  )
}
